import type { LucideIcon } from "lucide-react";
import { cn } from "@repo/ui/lib/utils";

interface StatsCardProps {
  title: string;
  value: number | string;
  icon: LucideIcon;
  variant?: "default" | "accent" | "destructive";
  subtitle?: string;
}

export const StatsCard = ({
  title,
  value,
  icon: Icon,
  variant = "default",
  subtitle,
}: StatsCardProps) => {
  return (
    <div className="card-elevated p-5">
      <div className="flex items-start justify-between">
        <div className="space-y-2">
          <p className="text-sm font-medium text-muted-foreground">{title}</p>
          <p className="text-3xl font-bold">{value}</p>
          {subtitle && (
            <p className="text-xs text-muted-foreground">{subtitle}</p>
          )}
        </div>
        <div
          className={cn(
            "p-2.5 rounded-lg",
            variant === "accent" && "bg-accent/10 text-accent",
            variant === "destructive" && "bg-destructive/10 text-destructive",
            variant === "default" && "bg-primary/10 text-primary"
          )}
        >
          <Icon className="w-5 h-5" />
        </div>
      </div>
    </div>
  );
};
